import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlanService {
  planDetail: any;
  freeTrialText: any;
  planAmount: any;

  constructor() { }

  setPlanDetails(plan){
    this.planDetail  = plan.plan_detail;
    this.freeTrialText = plan.free_trial_text;
    this.planAmount = plan.amount;
    localStorage.setItem('planInfo', this.planAmount);
  }
}
